import { observer } from "mobx-react-lite"
import React, { FC } from "react"
import { Appearance, ImageStyle, Linking, ViewStyle } from "react-native"
import { AutoImage, Button, Screen, Text } from "../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import { View } from "native-base"
import { color } from "../../../theme"
import config from "../../../utils/config"
import JalaAnalytic from "../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flexGrow: 1,
  alignItems: 'center',
  paddingHorizontal: 20
}

const IMAGE: ImageStyle = {
  height: '20%',
  width: '40%',
  marginVertical: 30
}

const { BASE_URL } = config()

export const FinanceScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function FinanceScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  // const { someStore, anotherStore } = useStores()

  const image = require("./ongoing.png");

  const handlePress = (open) => {
    let link = null;
    let mixpanelKey = null;
    if (open) {
      // Open WEB Finance
      // 'https://app.jala.tech/finances'
      // link = 'https://app.jala.tech/finances'
      link = `${BASE_URL}/finances`
      mixpanelKey = 'Mobile app: open web app - finance';
    } else {
      // Open WEB Siklus
      link = 'https://jala.tech/app#pricing-table'
      // link = `${BASE_URL}/id/pro-cycle/`
      mixpanelKey = 'Mobile app: open web app - learn siklus pro'
    }
    JalaAnalytic.log(mixpanelKey);
    Linking.openURL(link).catch();
  }

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar="light-content"
    >
      <View flex={1} mb="15px" alignItems="center" justifyContent="center">
        <AutoImage source={image} style={IMAGE} />
        <Text preset="title2" tx="financeScreen.ongoingFeatureTitle" mb="10px" textAlign="center" color={color.palette.darkestGrey} colorScheme={colorScheme} />
        <Text preset="body1" tx="financeScreen.ongoingFeatureSubtitle" textAlign="center" color={color.palette.grey} colorScheme={colorScheme} />
      </View>
      <Button testID="jala:id/open-web-button" tx="financeScreen.openWeb" colorScheme={colorScheme} onPress={() => handlePress(true)} />
      <View mb="20px" />
      <Button testID="jala:id/lear-pro-button" preset="outline" tx="financeScreen.learnProCycle" colorScheme={colorScheme} onPress={() => handlePress(false)} />
      <View mb="20px" />
    </Screen>
  )
})
